import produce from 'immer';
import {
  ITEM_DB_INFO_REQUEST,
  ITEM_DB_UPDATE,
  SET_ITEM_CONFIG
} from '../../constants/app/itemDBConstants';

const initialState = {
  materials : [],
};

const itemDBReducer = (state = initialState, action = {}) => produce(state, draft => {
  switch (action.type) {
    case ITEM_DB_UPDATE:
      break;
    case ITEM_DB_INFO_REQUEST:
      break;
    case SET_ITEM_CONFIG:
      draft.materials = action.materials;
      break;
    default:
      break;
  }
});

export default itemDBReducer;
